import { useEffect, useState } from 'react';

import logoSvg from '../../images/logos/insight_powered_by.svg';

const JourneyInsight = ({ playlist, onChange, customer }) => {
    return (
        <div className="InsightMotionalIntelligence">
            <div className="photo"></div>
            <div className="insight-motional-intelligence-contents">
                <div className="placeholder">
                        <div className="logo-container">
                            <img src={logoSvg} alt="Insight powered by Motional Intelligence" className="tab-icon" />
                        </div>
                        <div className="placeholder-message">
                            Insight analytics { playlist?.id ? 'for ' + playlist.label : ''} will be available soon.
                        </div>
                </div>
            </div>
        </div>
    );
};

export default JourneyInsight;
